document.addEventListener("DOMContentLoaded", () => {
  const story = document.querySelector("[data-story]")
  if (!story) return

  const steps = [...story.querySelectorAll("[data-story-step]")]
  const frames = [...story.querySelectorAll("[data-story-frame]")]

  const show = (active) => {
    steps.forEach((step, index) => {
      step.setAttribute("aria-current", index === active)
      step.classList.toggle("is-past", index < active)
    })
    frames.forEach((frame, index) => frame.classList.toggle("is-active", index === active))
  }

  // A step counts once it crosses the middle of the screen; scrolling itself stays untouched.
  const observer = new IntersectionObserver((entries) => {
    entries.filter((entry) => entry.isIntersecting).forEach((entry) => show(steps.indexOf(entry.target)))
  }, { rootMargin: "-50% 0px -50% 0px" })

  steps.forEach((step) => observer.observe(step))
  show(0)

  // Content only starts hidden once this runs, so it stays visible if the script never loads.
  story.classList.add("story--animate")
  const reveal = new IntersectionObserver((entries) => {
    entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
      entry.target.classList.add("is-visible")
      reveal.unobserve(entry.target)
    })
  }, { rootMargin: "0px 0px -15% 0px" })

  story.querySelectorAll(".story__step-text, .story__inline").forEach((element) => reveal.observe(element))
})
